module.exports = "<div class=\"tile\" [class.active]=\"status==='hoverOn'\">\n  <a class=\"stagger-elem nav-link p-0\" (click)=\"onDelete()\">\n    <span><i class=\"icon icon-trash\" aria-hidden=\"true\"></i></span>\n  </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/asset-delete/asset-delete.component.html
// module id = ./src/app/shared/components/asset-delete/asset-delete.component.html
// module chunks = main